import * as PropTypes from 'prop-types';
import * as React from 'react';

const Pill = ({ value, onClick }) =>
  (<li key={`pill-${value}`} className="filter-term">
    <span className="mr-half">{value}</span>
    <a className="filter-term-remove" rel="nofollow" onClick={e => onClick(e)}>
      <span className="fa fa-times" />
    </a>
  </li>);

Pill.propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Pill;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/search_pills/pill.jsx